/**
 * @generated SignedSource<<0a690a2171adf4de3d909da3e4c0188a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type GraphQLAgentPendingToolUseStatus = "APPROVED" | "PENDING" | "REJECTED" | "%future added value";
export type GraphQLMessageMessageRole = "AGENT" | "HUMAN" | "%future added value";
export type GraphQLMessageMessageType = "AGENT_PROCESS" | "AGENT_RESPONSE" | "ERROR_RESPONSE" | "USER_INPUT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type LlmConversationMessageList_llmConversation$data = {
  readonly id: any;
  readonly llmInteractions: ReadonlyArray<{
    readonly id: any;
    readonly pendingQuestions: ReadonlyArray<{
      readonly answersJson: any | null | undefined;
      readonly id: any;
      readonly questionsJson: any;
      readonly status: string;
      readonly toolUseId: string;
    }>;
  }>;
  readonly messages: ReadonlyArray<{
    readonly agentThoughtProcess: ReadonlyArray<{
      readonly subagentDescription: string | null | undefined;
      readonly subagentItems: ReadonlyArray<{
        readonly text: string | null | undefined;
        readonly thinking: string | null | undefined;
        readonly thinkingSummary: string | null | undefined;
        readonly toolUse: {
          readonly " $fragmentSpreads": FragmentRefs<"ToolCallsSection_toolCalls">;
        } | null | undefined;
      }> | null | undefined;
      readonly subagentOutput: string | null | undefined;
      readonly text: string | null | undefined;
      readonly thinking: string | null | undefined;
      readonly thinkingSummary: string | null | undefined;
      readonly toolUse: {
        readonly " $fragmentSpreads": FragmentRefs<"ToolCallsSection_toolCalls">;
      } | null | undefined;
    }>;
    readonly attachments: ReadonlyArray<{
      readonly downloadToken: string;
      readonly mimetype: string;
      readonly originalName: string;
      readonly size: number | null | undefined;
    }>;
    readonly content: string;
    readonly createdAt: any;
    readonly id: string;
    readonly llmInteractionId: string | null | undefined;
    readonly messageMetadata: {
      readonly agentVersion: string | null | undefined;
    } | null | undefined;
    readonly messageRole: GraphQLMessageMessageRole;
    readonly messageType: GraphQLMessageMessageType | null | undefined;
    readonly output: string | null | undefined;
    readonly toolCalls: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"ChecklistToolCallResult_toolCall" | "ToolCallsSection_toolCalls">;
    }>;
    readonly updatedAt: any;
    readonly " $fragmentSpreads": FragmentRefs<"AgentThoughtProcess_formattedMessage" | "messageWithToolReferences_formattedMessage">;
  }>;
  readonly pendingToolUses: ReadonlyArray<{
    readonly id: string;
    readonly reviewedAt: any | null | undefined;
    readonly reviewedBy: string | null | undefined;
    readonly status: GraphQLAgentPendingToolUseStatus;
    readonly toolUseId: string;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"AgentThoughtProcess_llmConversation">;
  readonly " $fragmentType": "LlmConversationMessageList_llmConversation";
};
export type LlmConversationMessageList_llmConversation$key = {
  readonly " $data"?: LlmConversationMessageList_llmConversation$data;
  readonly " $fragmentSpreads": FragmentRefs<"LlmConversationMessageList_llmConversation">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "toolUseId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v3 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ToolCallsSection_toolCalls"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thinking",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thinkingSummary",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "GraphQLMessageToolCall",
  "kind": "LinkedField",
  "name": "toolUse",
  "plural": false,
  "selections": [
    (v3/*: any*/)
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LlmConversationMessageList_llmConversation",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLAgentPendingToolUse",
      "kind": "LinkedField",
      "name": "pendingToolUses",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reviewedBy",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reviewedAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "last",
          "value": 10
        }
      ],
      "concreteType": "GraphQLLlmInteraction",
      "kind": "LinkedField",
      "name": "llmInteractions",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLAgentPendingQuestion",
          "kind": "LinkedField",
          "name": "pendingQuestions",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "questionsJson",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "answersJson",
              "storageKey": null
            },
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": "llmInteractions(last:10)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLFormattedMessage",
      "kind": "LinkedField",
      "name": "messages",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "messageRole",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "messageType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "content",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "output",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "llmInteractionId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLChatAttachment",
          "kind": "LinkedField",
          "name": "attachments",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "originalName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mimetype",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "size",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "downloadToken",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLMessageMetadata",
          "kind": "LinkedField",
          "name": "messageMetadata",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "agentVersion",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLMessageToolCall",
          "kind": "LinkedField",
          "name": "toolCalls",
          "plural": true,
          "selections": [
            (v3/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ChecklistToolCallResult_toolCall"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLAgentThoughtProcessItem",
          "kind": "LinkedField",
          "name": "agentThoughtProcess",
          "plural": true,
          "selections": [
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subagentDescription",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subagentOutput",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "GraphQLAgentThoughtProcessItem",
              "kind": "LinkedField",
              "name": "subagentItems",
              "plural": true,
              "selections": [
                (v4/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/),
                (v7/*: any*/)
              ],
              "storageKey": null
            },
            (v7/*: any*/)
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "messageWithToolReferences_formattedMessage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AgentThoughtProcess_formattedMessage"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AgentThoughtProcess_llmConversation"
    }
  ],
  "type": "GraphQLLlmConversation",
  "abstractKey": null
};
})();

(node as any).hash = "100e4b24f176a94fd647bf38867a583f";

export default node;
